import { TagsResponse } from '../../../models/tags/TagsResponse';
import { getTags } from '../../services/tags/TagsService';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_TAGS_KEYS } from '../../query/tags/keys';
import { useEffectiveAddons } from '../../../contexts/effective-features/EffectiveFeaturesContext';

/**
 * Tagi projektu do rozwiązywania marek (klucze `chatbeat_tag_name_*`, etykiety). Z addonem
 * `KEYWORDS_PAGE` tagi nie grają w ogóle — liczymy po scalonych markach — więc hook zwraca pustą listę
 * i żaden konsument nie zbuduje klucza tagu. `raw` = zarządzanie samymi tagami (strona Tagi).
 */
export const useGetTags = (projectId: number | null, options?: { raw?: boolean }) => {
  const queryClient = useQueryClient();
  const groupsBrands = useEffectiveAddons().includes('KEYWORDS_PAGE');
  const queryEnabled = !!projectId && (options?.raw || !groupsBrands);

  const {
    data: tags,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<TagsResponse[]>({
    queryKey: [GET_TAGS_KEYS, projectId],
    queryFn: () => getTags(projectId!),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
  });

  return {
    tags: queryEnabled ? tags ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_TAGS_KEYS, projectId],
        refetchType: 'active',
      }),
  };
};
